export default "__VITE_ASSET__Cbzm_5tT__"